import { useSettingsContext } from '@src/contexts';
import { AspectSettings, AudioSettings, GeneralSettings, SidebarMenu, VideoSettings } from './partials';

const SettingsContent = () => {
  const selectedMenuItem = useSettingsContext().selectedMenuItem;
  
  const renderSettings = () => {
    switch (selectedMenuItem) {
      case 'audio':
        return <AudioSettings />;
      case 'video':
        return <VideoSettings />;
      case 'aspect':
        return <AspectSettings />;
      case 'general':
        return <GeneralSettings />;
      default:
        return null;
    }
  };

  return (
    <div className="settings-container">
      <SidebarMenu />
      <div className="body-container">{renderSettings()}</div>
    </div>
  );
};

export default SettingsContent;
